export function getDateRange(min, max) {
    return +max - +min;
}
